import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IVendorData } from "../../model/IVendorData";

// TODO remove or add relevant data

export default class VendorDataParser implements IBaseDataParser<IVendorData> {
    check(data: any): boolean {
        return data?.data?.playId || data?.data?.lastSessionData?.playId;
    }

    parse(data): IVendorData {
        return {
            playId: data?.data?.playId || data?.data?.lastSessionData?.playId,
            lastPlayState: data?.data?.lastSessionData?.lastPlayState || 0
        };
    }
}